import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';
import { translateString } from '@src/util/intl/translateString';

import EventName from '@src/components/TriggersList/component/EventName';

import { DASHBOARDS_FORMS } from '../../../constants';
import { getTableActionButtons } from '../actionButtons/tableActionButtons';
import { renderTableContent } from '../renderers/tableRenderer';
import { useTableData } from '../transformers/tableTransformer';

import type { WidgetConfig } from './types';

export const tableDashboardConfig = (additionalProps: Record<string, unknown>): WidgetConfig => ({
  activeSingleFilter: true,
  initialFilters: {
    userName: {
      value: '',
      label: translateString('dashboards.events.table.auxFields.userName'),
      valueTranslated: '',
      valueType: 'string',
      clearValue: '',
      key: 'userName',
    },
    eventType: {
      value: '',
      label: translateString('dashboards.events.table.auxFields.eventType'),
      valueTranslated: '',
      valueType: 'string',
      clearValue: '',
      key: 'eventType',
    },
  },
  collectionName: FSCollections.TABLES,
  componentType: DASHBOARDS_FORMS.EVENT_TABLE,
  op: API_OPERATIONS.TABLE_DASHBOARD,
  useDataHook: useTableData,
  additionalProps,
  renderContent: renderTableContent,
  getSubTitle: ({ data }) => {
    if (!data) return null;
    const { tableCardForm, totalEvents } = data;
    return (
      <EventName
        eventColor={tableCardForm?.color}
        formName={`${tableCardForm?.name} (${totalEvents || 0})`}
        eventIcon={tableCardForm?.icon}
      />
    );
  },
  getActionButtons: getTableActionButtons,
});
